export const ListColors = [
  "#845EC2",
  "#D65DB1",
  "#FF6F91",
  "#FF9671",
  "#FFC75F",
  "#F9F871",
  "#9BDE7E",
  "#4BBC8E",
  "#039590",
  "#1C6E7D",
];
